import { Badge } from '@/components/ui/badge';
import { ClaudeTaskCommand } from '@/types/claudeTask';

interface TaskCommandBadgeProps {
  command: ClaudeTaskCommand | string;
  className?: string;
}

export function TaskCommandBadge({ command, className = '' }: TaskCommandBadgeProps) {
  const getCommandColor = (command: string) => {
    switch (command) {
      case ClaudeTaskCommand.RUN_DIFF:
        return 'bg-purple-100 text-purple-800 hover:bg-purple-100';
      case ClaudeTaskCommand.SCRAPE:
        return 'bg-cyan-100 text-cyan-800 hover:bg-cyan-100';
      case ClaudeTaskCommand.ANALYZE:
        return 'bg-blue-100 text-blue-800 hover:bg-blue-100';
      case ClaudeTaskCommand.EXTRACT:
        return 'bg-green-100 text-green-800 hover:bg-green-100';
      case ClaudeTaskCommand.FIX_DIFF:
        return 'bg-amber-100 text-amber-800 hover:bg-amber-100';
      case ClaudeTaskCommand.RUN_ADD:
        return 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100';
      case ClaudeTaskCommand.RUN_ADD_PAGE:
        return 'bg-teal-100 text-teal-800 hover:bg-teal-100';
      case ClaudeTaskCommand.DISCOVERY:
        return 'bg-indigo-100 text-indigo-800 hover:bg-indigo-100';
      default:
        return 'bg-gray-100 text-gray-800 hover:bg-gray-100';
    }
  };

  const getCommandText = (command: string) => {
    switch (command) {
      case ClaudeTaskCommand.RUN_DIFF:
        return 'Run Diff';
      case ClaudeTaskCommand.SCRAPE:
        return 'Scrape';
      case ClaudeTaskCommand.ANALYZE:
        return 'Analyze';
      case ClaudeTaskCommand.EXTRACT:
        return 'Extract';
      case ClaudeTaskCommand.FIX_DIFF:
        return 'Fix Diff';
      case ClaudeTaskCommand.RUN_ADD:
        return 'Add Page';
      case ClaudeTaskCommand.RUN_ADD_PAGE:
        return 'Add Sub-Page';
      case ClaudeTaskCommand.DISCOVERY:
        return 'Discovery';
      default:
        return command;
    }
  };

  return (
    <Badge className={`${getCommandColor(command)} ${className}`}>
      {getCommandText(command)}
    </Badge>
  );
}
